export default function TabComponent({ tabData, activeTab, onTabChange }) {
    return (
        <div className="w-full flex flex-col items-center">
            <div className="flex items-center justify-center bg-white border border-blue-200 rounded-xl p-1 shadow-sm">
                {tabData.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`
                            px-4 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 border
                            ${activeTab === tab.id
                                ? "bg-blue-500 text-white border-blue-500 shadow-sm"
                                : "bg-white text-blue-600 border-transparent hover:bg-blue-50"
                            }
                        `}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
